import { useState } from 'react';
import { Link as RouterLink } from 'react-router';
import { Alert, Box, Button, Card, FormControl, FormLabel, Input, Link, Stack, Typography } from '@mui/joy';

import { APIBusinessForgotPassword } from '../../api_business_auth';

export default function BusinessForgotPasswordPage() {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [done, setDone] = useState(false);

    const submit = async () => {
        if (!email.trim()) return;
        setLoading(true);
        try { await APIBusinessForgotPassword(email.trim()); } catch (e) { /* всё равно success */ }
        setDone(true);
        setLoading(false);
    };

    return (
        <Box sx={{ minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', px: 2 }}>
            <Card sx={{ p: 3, borderRadius: 'xl', boxShadow: 'lg', maxWidth: 420, width: '100%' }}>
                <Typography level="h4" sx={{ mb: 1.5 }}>Восстановление пароля</Typography>
                {done ? (
                    <Alert color="success">
                        Если аккаунт с таким email существует, мы отправили ссылку для сброса пароля.{' '}
                        <Link component={RouterLink} to="/business/login">Ко входу</Link>
                    </Alert>
                ) : (
                    <Stack spacing={1.5}>
                        <FormControl>
                            <FormLabel>Email</FormLabel>
                            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                                   onKeyDown={(e) => e.key === 'Enter' && submit()} />
                        </FormControl>
                        <Button onClick={submit} loading={loading}>Отправить ссылку</Button>
                        <Box sx={{ textAlign: 'center' }}>
                            <Link component={RouterLink} to="/business/login" level="body-sm">← Ко входу</Link>
                        </Box>
                    </Stack>
                )}
            </Card>
        </Box>
    );
}